import PlacesAutocomplete from "stimulus-places-autocomplete"

class AddressData {
  build(address) {
    this.address = address
    return this
  }

  addressLineOne() {
    return `${this.#streetNumber()} ${this.#route()}`.trim()
  }

  addressLineTwo() {
    return this.address.subpremise || ""
  }

  city() {
    // fallback rules for UK/local variations
    return (
      this.address.locality ||
      this.address.postal_town ||
      this.address.administrative_area_level_3 ||
      this.address.administrative_area_level_2 ||
      ""
    )
  }

  state() {
    return this.address.administrative_area_level_1 || ""
  }

  postalCode() {
    return this.address.postal_code || ""
  }

  country() {
    return this.address.country || ""
  }

  #streetNumber() {
    return this.address.street_number || ""
  }

  #route() {
    return this.address.route || ""
  }
}

export default class extends PlacesAutocomplete {
  static targets = [
    "address",
    "addressLineOne",
    "addressLineTwo",
    "city",
    "postalCode",
    "country",
    "state",
  ]

  initAutocomplete() {
    if (!window.google?.maps?.places || this.autocomplete) return
    super.initAutocomplete()
  }

  setAddressComponents(address) {
    const addressData = new AddressData().build(address)

    this.addressLineOneTarget.value = addressData.addressLineOne()
    this.addressLineTwoTarget.value = addressData.addressLineTwo()
    this.cityTarget.value = addressData.city()
    this.stateTarget.value = addressData.state()
    this.postalCodeTarget.value = addressData.postalCode()
    this.countryTarget.value = addressData.country()
  }

  formatAddressComponents(addressComponents) {
    const data = super.formatAddressComponents(addressComponents)

    addressComponents.forEach((component) => {
      const type = component.types[0]

      if (type === "country") {
        data[type] = component.short_name // e.g. "CA"
      } else {
        data[type] = component.long_name
      }
    })

    return data
  }
}
